<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="850px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <div>
      <el-form ref="form" :model="formData" size="mini" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-upload
                  class="contacts-uploader mt-3"
                  action="/oss/ossUploadReturnUrlAndFileId"
                  :show-file-list="false"
                  :data="fileData"
                  :headers="fileHeaders"
                  :on-success="handleSuccess"
                >
                  <img
                    v-if="formData.imageUrl"
                    :src="formData.imageUrl"
                    class="contactsEvent"
                  />
                  <i
                    v-else
                    class="el-icon-plus contactsEvent-uploader-icon"
                  ></i>
                </el-upload>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="16">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_fabricScmName') || '店铺名称'"
                  prop="resFabricScmName"
                >
                  <el-input
                    v-model="formData.resFabricScmName"
                    maxlength="500"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_fabricScmAddress') || '店铺地址'"
                  prop="resFabricScmAddress"
                >
                  <el-input
                    v-model="formData.resFabricScmAddress"
                    maxlength="500"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  :label="$l('table_label_contactName') || '联系人'"
                  prop="contactName"
                >
                  <el-input
                    v-model="formData.contactName"
                    maxlength="50"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('table_label_contactMobile') || '手机号'"
                  prop="contactMobile"
                >
                  <el-input
                    v-model="formData.contactMobile"
                    maxlength="50"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  :label="$l('table_label_contactPhone') || '固定电话'"
                  prop="contactPhone"
                >
                  <el-input
                    v-model="formData.contactPhone"
                    maxlength="50"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('table_label_contactEmail') || '联系人Email'"
                  prop="contactEmail"
                >
                  <el-input
                    v-model="formData.contactEmail"
                    maxlength="50"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  :label="$l('table_label_contactJob') || '联系人职务'"
                  prop="contactJob"
                >
                  <el-input
                    v-model="formData.contactJob"
                    maxlength="50"
                    :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close()">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button size="small" type="primary" @click="save()">{{
        $l('INDEX.btn_save') || '保存'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import util from '@/libs/util'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: {
    resFabricScmCode: { type: String, default: '' },
    resFabricRecordCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    title: {
      type: String,
      default: '识别名片',
    },
    imageUrl: { type: String, default: '' },
    imageCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
      rules: {
        contactName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        contactMobile: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        resFabricScmName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        resFabricScmAddress: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.imageUrl) {
        this.$set(this.formData, 'imageCode', this.imageCode)
        this.$set(this.formData, 'imageUrl', this.imageUrl)
        this.businessCardUrl(this.imageUrl)
      }
    },
    handleSuccess(res) {
      if (res.status === 200) {
        this.formData.imageCode = res.body.fileId
        this.formData.imageUrl = res.body.url
        // 名片OCR
        this.businessCardUrl(this.formData.imageUrl)
      }
    },
    async save() {
      const { imageUrl, imageCode } = this.formData
      if (!imageUrl || !imageCode) {
        this.$message.warning('请上传名片')
        return
      }
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const confirm = await this.$confirm(
        this.$l('tips_cardOcr') || '是否要使用该图片上的信息覆盖当前店铺信息',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      this.formData.resFabricScmCode = this.resFabricScmCode
      this.$api
        .resFabricScmOcrSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },

    // 名片OCR
    businessCardUrl(imageUrl) {
      this.loadingOpen()
      this.$api
        .businessCardUrlApi({
          imageUrl: imageUrl,
        })
        .then((res) => {
          if (res.body.success) {
            let resData = res.body
            //设置姓名
            this.$set(this.formData, 'contactName', resData.name)
            //设置职务
            this.$set(
              this.formData,
              'contactJob',
              this.arrayToString(resData.title)
            )
            //手机号码
            this.$set(
              this.formData,
              'contactMobile',
              this.arrayToString(resData.tel_cell)
            )
            //固定电话
            this.$set(
              this.formData,
              'contactPhone',
              this.arrayToString(resData.tel_work)
            )
            //email
            this.$set(
              this.formData,
              'contactEmail',
              this.arrayToString(resData.email)
            )
            //公司名称
            this.$set(
              this.formData,
              'resFabricScmName',
              this.arrayToString(resData.company)
            )
            //公司地址
            this.$set(
              this.formData,
              'resFabricScmAddress',
              this.arrayToString(resData.addr)
            )
          }
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    // 设置内容拼接成string
    arrayToString(array) {
      let str = ''
      array.forEach((item) => {
        if (str) {
          str = str + ',' + item
        } else {
          str = item
        }
      })
      return str
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.contacts-uploader {
  border: 1px dashed #d9d9d9;
  width: 256px !important;
  height: 204px;
  line-height: 204px !important;
  text-align: center;
}
.contactsEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 256px !important;
  height: 204px;
  line-height: 204px !important;
  text-align: center;
}
.contactsEvent {
  width: 256px !important;
  height: 204px;
  display: block;
}

::v-deep {
  .el-form {
    > div:first-child {
      border-top: 0px solid #ebeef5 !important;
    }
    > div {
      border: 0px solid #ebeef5 !important;
      border-top: none;
    }
  }
}
</style>
